import React from "react"
import theme from "../../../config/theme";

const ProductTitle = (props) => {
    const fontSizeBrackets = {
        long: {
            s: '13px',
            m: '13px',
            l: '13px'
        },
        medium: {
            s: '13px',
            m: '13px',
            l: '13px'
        },
        short: {
            s: '13px',
            m: '13px',
            l: '13px'
        }
    }

    let xlLength =  50;
    let xlSubstr = 50;
    let lLength = 40;
    let sLength = 20;

    let children = props.children;

    if(props.children.length > xlLength) {
        children = children.substr(0, xlSubstr) + '...';
    }

    const currentBracket = children.length > lLength ? 'long' :
                           children.length > sLength ? 'medium' :
                           'short';

    return (
        <div className="product-title" title={props.children}>
            <style jsx>{`
                .product-title {
                    font-size: 13px;
                    font-weight: 600;
                    color: ${theme.colors.base.base};
                    background-color: ${theme.colors.base.white};
                    justify-content: center;
                    text-align: center;
                    height: 37px;
                    margin-bottom: 2px;
                    width: 100%;
                    display: flex;
                    align-items: flex-start;
                    padding: 5px 0px;
                    box-sizing: border-box;
                    overflow: hidden;

                    ${props.variant === 'showcase' ? `
                        margin-top: 10px;
                        margin-bottom: 10px;
                    ` : ''}
                }

                @media only screen and (max-width: ${theme.responsive.m}px) {
                    .product-title {
                        font-size: ${fontSizeBrackets[currentBracket].m};
                        margin-bottom: 0px;
                        ${props.variant === "showcase" ? "height: 40px;" : ""}
                        margin-top: ${props.variant === 'showcase' ? '5px' : 0};

                    } 
                    
                }

                @media only screen and (max-width: ${theme.responsive.s}px) {
                    .product-title {
                        font-size: ${fontSizeBrackets[currentBracket].s};
                    } 
                }

            `}</style>
            {props.goro ? "Goro's " : ""} {children}
        </div>
    )
}

export default ProductTitle;